<template>
    <header class="topnavbar-wrapper">
        <!-- START Top Navbar-->
        <nav class="navbar topnavbar">
            <!-- START navbar header-->
            <div class="navbar-header">
                <a class="navbar-brand" href="/">
                    <div class="brand-logo">
                        <img class="img-fluid" src="img/NBC_Mosaic_Logo_White_47x34.png" alt="App Logo">
                    </div>
                    <div class="brand-logo-collapsed">
                        <img class="img-fluid" src="img/NBC_Mosaic_Logo_mark_CMYK_29x40.png" alt="App Logo">
                    </div>
                </a>
            </div>
            <!-- START Left navbar-->
            <ul class="navbar-nav me-auto flex-row">
                <li class="nav-item">
                    <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
                    <a href="" class="nav-link sidebar-toggle d-md-none" @click.prevent="toggleOffcanvas">
                        <em class="fas fa-bars"></em>
                    </a>
                </li>
                <p-feature-flag ref="multiStoreFlag" name="MultiStore">
                    <li class="nav-item">
                         <p-select
                            v-model.number ='locationId'
                            data-type ='locations'
                            name = "Location Selector"
                            :set-invalid-value-to-first-option = 'true'
                            @change="setLocation"
                           style="min-width:200px"
                           class="ms-3 "
                        />
                    </li>
                </p-feature-flag>
            </ul>
            <!-- END Left navbar-->
            <!-- END navbar header-->
            <ul class="navbar-nav flex-row">
                <li class="nav-item">
                    <a href="" class="nav-link support-chat-link" title="Chat with Support" aria-label="Chat with Support" @click.prevent="openSupportChat">
                        <em class="fas fa-comment-dots fa-lg"></em>
                    </a>
                </li>
                <li class="nav-item" @mouseover="showHelpMenu" @mouseleave="hideHelpMenu">
                        <div :title="'Help Menu'" alt="Help Menu" class="nav-link">
                            <em class="fas fa-question-circle fa-lg fa-solid"></em>
                        </div>
                        <div v-if="helpMenuVisible" class="absolute-position dropdown dropdown-menu-right sidebar-nav sidebar-subnav nav-floating" tag="ul">
                            <li>
                                <a :href="'https://nebook.atlassian.net/wiki/spaces/CS/pages/2164129838/Mosaic+Release+Notes+and+Recordings'"
                                    class="nav-item"
                                    active-class="active"
                                    tag="li"
                                    target="_blank"
                                >
                                    <span>View Release Notes</span>
                                </a>
                            </li>
                            <li>
                                <a :href="'https://nebook.atlassian.net/wiki/spaces/CS/pages/2164097071/Mosaic+Knowledge+Base+and+Documentation'"
                                    active-class="active"
                                    tag="li"
                                    target="_blank"
                                >
                                    <span>Open Mosaic Documentation</span>
                                </a>
                            </li>
                            <li>
                                <a :href="'https://nebook.atlassian.net/servicedesk/customer/portal/1/group/53'"
                                    active-class="active"
                                    tag="li"
                                    target="_blank"
                                >
                                    <span>Create Support Ticket</span>
                                </a>
                            </li>
                            <li>
                                <a :href="'https://prismrbs.wyzed.com/'"
                                    active-class="active"
                                    tag="li"
                                    target="_blank"
                                >
                                    <span>Wyzed Training Sign-up</span>
                                </a>
                            </li>
                        </div>                          
                </li>
                <!-- START Offsidebar button-->
                <li class="nav-item ps-3">
                    <a href="" class="nav-link" @click.prevent="logout" @click.middle.prevent="logout">
                        Log Out
                    </a>
                </li>
                <!-- END Offsidebar.prevent menu-->
            </ul>
        </nav>      
        <!-- END Top Navbar-->
    </header>
</template>

<script>
    import userManager from '@/services/SecurityService';
    import SidebarToggle from './SidebarToggle.js';
    import NavigationGuard from '@/components/mixins/NavigationGuard.js';
    import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
    import { useCurrentUserStore } from '@/stores/currentUser.js';
    import { useAppStateStore } from '@/stores/appState.js';

    export default {
        name: 'Header',
        mixins: [SidebarToggle, NavigationGuard],
        computed: {
            locationCacheKey() {
                return "SelectedLocationId" + useCurrentUserStore().getCurrentUserId;
            },

            selectedLocation(){
                return useAppStateStore().getSelectedLocationId;
            }
        },
        data: () => {
            return {
                navSearchOpen: false,
                locationId: null,
                helpMenuVisible: false
            }
        },
        watch: {
            selectedLocation: {
                deep: true,
                handler: function(newVal) {
                    this.locationId = newVal;
                }
            }
        },
        methods: {
            closeNavSearch() {
                this.navSearchOpen = false;
            },
            async logout() {
                 var isFormDirty = false;
                 if (this.$parent && this.$parent.$children) {
                     isFormDirty = this.$parent.$children.some(x => x.formIsDirty);
                 }
                  var promptOk
                 if (isFormDirty) {
                      promptOk = await this.$bvModal
                         .msgBoxConfirm([this.displayMessage]);
                     if (promptOk) {
                         this.$parent.$children.forEach(x => {
                             if (x.formIsDirty && x.dataLoaded) {
                                 x.dataLoaded();
                             }
                         });
                     }
                     else {
                         return;
                     }
                 }
                 else {
                    promptOk = await this.$bvModal
                         .msgBoxConfirm('Are you sure you want to logout?');
                     if (!promptOk) {
                         return;
                     }
                 }
                 userManager.signoutRedirect();
            },
            setLocation(value) {
                useAppStateStore().updateSelectedLocationId(parseInt(value) || null);
                localStorage.setItem(this.locationCacheKey, value);
                if(this.$route.path != '/home'){
                    this.$router.push('/home');
                }
            },
            showHelpMenu() {
                this.helpMenuVisible = true;
            },
            hideHelpMenu() {
                this.helpMenuVisible = false;
            },
            openSupportChat() {
                // window.CSM is defined by the widget snippet in App.vue; calls queue until the widget loads
                if (typeof window.CSM === 'function') {
                    window.CSM('open');
                }
            }
        },
        async created() {
            this.locationId = localStorage.getItem(this.locationCacheKey);
            if(this.locationId == null){
                //if no previously chosen location is found, we load the first option available and set that as the selection
                this.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
                localStorage.setItem(this.locationCacheKey, this.locationId);
            }

            useAppStateStore().updateSelectedLocationId(parseInt(this.locationId) || null);
        }
    }
</script>

<style scoped lang="scss">
:deep(.navbar ) {
    z-index: 200;
}

:deep(.form-group) {
    margin-bottom: 0rem !important;
}

:deep(.compact-control ) {
    width:150px;
}

:deep(.absolute-position ) {
    position: absolute
}
</style>